import {Tabs} from '@/components';
import type {TabItem} from '@/types';

import AppRatesList from './App';
import OTCTrades from './OTCTrades';
import PromoTiersList from './Promo';
import RatesUpload from './Upload';

const Rates = () => {
  const ratesTabs: TabItem[] = [
    {
      id: 'app-rates',
      title: 'App Rates',
      content: <AppRatesList />,
    },
    {
      id: 'upload',
      title: 'Upload Rates',
      content: <RatesUpload />,
    },
    {
      id: 'otc-trades',
      title: 'OTC Trades',
      content: <OTCTrades />,
    },
    {
      id: 'promo-rates',
      title: 'Promo Tiers',
      content: <PromoTiersList />,
    },
  ];
  return <Tabs tabs={ratesTabs} queryKey="tab" />;
};
export default Rates;
